import type { HTMLAttributes, ReactNode } from "react";
import { Toaster as SonnerToaster, toast } from "sonner";

import { cn } from "../cn";

/** Lugar dos toasts; ponha uma vez na raiz do app. Use `toast("...")` para mostrar. */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      toastOptions={{
        className: "!rounded-xl !border-line !bg-paper !text-ink !font-sans",
      }}
    />
  );
}

export { toast };

/** Estado vazio: o que falta e o próximo passo (nunca uma tela em branco). */
export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-[var(--radius-card)] border border-dashed border-line bg-paper px-6 py-10 text-center">
      {icon ? <div className="text-gold-text">{icon}</div> : null}
      <p className="font-display text-card-sm text-ink">{title}</p>
      {description ? <p className="max-w-sm text-body-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}

/** Bloco de carregamento. Respeita `prefers-reduced-motion`. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn("animate-pulse rounded-lg bg-surface motion-reduce:animate-none", className)}
      {...props}
    />
  );
}
